import {FC, useEffect, useState} from 'react'
import {useParams} from 'react-router-dom'
import {loginAsUser} from './core/_requests'

// /admin/login-as/:id — shareable link that logs the signed-in admin straight
// into a customer's account (uses the audited login-as endpoint).
const LoginAsRedirect: FC = () => {
  const {id} = useParams()
  const [error, setError] = useState('')
  useEffect(() => {
    if (!id) return
    loginAsUser(id)
      .then(({data}) => {
        if (data && data.api_token) {
          window.location.replace(`/auth/login-as?token=${encodeURIComponent(data.api_token)}`)
        } else setError('לא התקבל טוקן')
      })
      .catch(() => setError('ההתחברות ללקוח נכשלה'))
  }, [id])
  return <div style={{padding: 40, textAlign: 'center'}}>{error || 'מתחבר ללקוח...'}</div>
}

export default LoginAsRedirect
